export default __webpack_public_path__ + "static/media/eur.026edd29.png";